module.exports = __webpack_public_path__ + "3db56c2aafbe11ab661b01da21c419a3.pdf";